import { Link as RouterLink } from 'react-router-dom'
import { Box, Button, Stack, Typography } from '@mui/material'

export function NotFoundPage() {
  return (
    <Box sx={{ minHeight: '60vh', display: 'grid', placeItems: 'center' }}>
      <Stack spacing={2} sx={{ alignItems: 'center', textAlign: 'center' }}>
        <Typography variant="h1">Página no encontrada</Typography>
        <Typography variant="body2" color="text.secondary">
          La dirección a la que intentó acceder no existe.
        </Typography>
        <Button component={RouterLink} to="/" variant="contained">
          Volver al panel
        </Button>
      </Stack>
    </Box>
  )
}
